export default __webpack_public_path__ + "static/media/807.67912c47.png";